<template>
    <Modal :show="showFunPlayModal" @close="showFunPlayModal = false" :closeable="true" maxWidth="'4xl'" extraClasses="rounded-lg">
        <div class="bg-blu-900 text-center  rounded p-4 min-w-[300px]">
            <p class="font-bold">{{ value?.nm }}</p>
            <div class="flex items-center gap-10 justify-center mt-6">
                <DefaultButton class="bg-neutral-600/75 text-white" @click="playFun">{{ $t('terms.modal.fun_play') }}</DefaultButton>
                <DefaultButton @click="playG">{{ $t('terms.modal.play') }}</DefaultButton>
            </div>
        </div>
    </Modal>
  </template>
  
<script setup>
import { ref } from 'vue';
import { useI18n } from 'vue-i18n';
import Modal from '@/components/Modal.vue';
import DefaultButton from '@/components/Buttons/DefaultButton.vue';

const props = defineProps({
    value:String | Number
});

const { t } = useI18n();
const showFunPlayModal = ref(false);
const emit = defineEmits(['play']);


const playFun = () => {
    emit('play', { demo: true });
    showFunPlayModal.value = false;
}
const playG = () => {
    emit('play', { demo: false });
    showFunPlayModal.value = false;
}
defineExpose({
    openModal: (data) => {
        showFunPlayModal.value = true;
    }
});
</script>